// @flow
import React from "react";
import { GlobalProvider } from "../common/GlobalContext";
import type {
  $Site,
  $SiteOffice,
  $Agent,
  $Team,
  $SiteOfficeBroker,
} from "flow/types";

import ThreeCol from "./Footers/ThreeCol";
import TwoLevel from "./Footers/TwoLevel";
import Disclaimer from "./Footers/compliance/Disclaimer";
import LicensedState from "./Footers/compliance/LicensedState";
import CustomDisclaimer from "./Footers/compliance/CustomDisclaimer";
import { PROVIDERS_OUTSIDE_US } from "../../../../lib/constant";

type $Props = {
  agent?: $Agent,
  compliance: Object,
  footerPod: string,
  isEqualHousingOpportunity: boolean,
  office?: $SiteOffice,
  privacyPolicy: { href: string, label: string },
  accessibility: { href: string, label: string },
  site: $Site,
  siteUser: Object,
  team?: $Team,
  tenantConfig: Object,
  theme: Object,
  brokers: Array<$SiteOfficeBroker>,
};

const Footer = ({
  agent,
  compliance,
  footerPod,
  isEqualHousingOpportunity,
  office,
  privacyPolicy,
  accessibility,
  site,
  siteUser,
  team,
  tenantConfig,
  theme,
  brokers,
}: $Props) => (
  <GlobalProvider
    agent={agent}
    compliance={compliance}
    footerPod={footerPod}
    isEqualHousingOpportunity={
      site &&
      site.datastoreProviderIds.every((dpi) =>
        PROVIDERS_OUTSIDE_US.includes(dpi)
      )
        ? false
        : isEqualHousingOpportunity
    }
    office={office}
    privacyPolicy={privacyPolicy}
    accessibility={accessibility}
    site={site}
    siteUser={siteUser}
    team={team}
    tenantConfig={tenantConfig}
    theme={theme}
    withStyleReset={false}
    brokers={brokers}
  >
    {footerPod === "threeCols" ? <ThreeCol /> : null}
    {footerPod === "twoToneAndTwoLevelFooter" ? <TwoLevel /> : null}
    <Disclaimer />
    <CustomDisclaimer />
    <LicensedState />
  </GlobalProvider>
);

export default Footer;
